import Logo from 'src/assets/image/logo-vertical.svg?react'
import LanguageSelector from 'src/components/molecules/language-selector'

import { Col, Flex, Row } from 'antd'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { version } from '../../../package.json'

type SingInTemplateProps = {
  children: React.ReactNode
}

export default function SignInLayout({ children }: SingInTemplateProps) {
  const { i18n } = useTranslation()

  return (
    <Flex vertical className="m-0 min-h-full bg-bg-light p-2.5">
      <Flex
        vertical
        justify="space-between"
        className="m-0 w-full flex-1 rounded-2xl bg-bg-base"
      >
        <Row justify="end" className="m-4">
          <Col>
            <LanguageSelector />
          </Col>
        </Row>

        <Row justify="space-evenly" align="middle">
          <Col>
            <Link to="/">
              <Logo data-testid="myinfocentre-logo" />
            </Link>
          </Col>
          <Col>{children}</Col>
        </Row>

        <Row>
          {import.meta.env.VITE_MODE !== 'production' && (
            <Col
              span={24}
              data-testid="signin-disclaimer-msg"
              className="min-h-12 rounded-b-2xl bg-bg-medium p-2 text-center text-text-medium"
            >
              {i18n.t('signIn.disclaimer')} - v{version} - {import.meta.env.VITE_MODE}
            </Col>
          )}
        </Row>
      </Flex>
    </Flex>
  )
}
